import { Component, HostListener, OnInit } from '@angular/core';
import { catchError, take } from 'rxjs/operators';
import { SlideSheetService } from '../../../../services/slide-sheet.service';
import { ConnectPara, DefaultConfig, ExchangeConfigInfo, ExchangeConnectModel, SettingConfig } from '../../../../tamalelibs/models/exchange-connect.model';
import { AuthService } from '../../../../tamalelibs/services/auth.service';
import { ExchangeService } from '../../../../tamalelibs/services/exchange.service';
import { SlideSheetActionTypes } from '../../../slide-sheet/slide-sheet.model';
import { of as observableOf } from 'rxjs';
import { DateHelperService } from '../../../../tamalelibs/services/date-helper.service';
import { ExchagnePanelService } from '../../../exchange/exchange-panel/exchange-panel.service';
import { Subscription } from 'rxjs';
import { OnDestroy } from '@angular/core';
import { ToastService } from '../../../../widgets/toast/toast.service';
import { NotificationOptions, NotificationStyles } from '../../../../widgets/notification/notification.model';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { ExchangeStatus, ExchangeSyncStatus } from '../../../../redux/actions/exchange.actions';
import { getSystemConfigState } from '../../../../redux/reducers/system-config-view.reducer';
import { StoreQuerierService } from '../../../../services/store-querier.service';
import { EmailSettingService } from '../../../../services/email-setting.service';
import { StringLiteralsPipe } from '../../../../pipes/translate.pipe';

const restart = StringLiteralsPipe.translate('email.restart');
const status = StringLiteralsPipe.translate('email.status');

// used to send the color to server
export const COLOR_VALUES = [
    'Red', 'Orange', 'Brown', 'Yellow', 'Green', 'Teal', 'Olive', 'Blue', 'Purple', 'Cranberry', 'Steel', 'DarkSteel', 'Gray',
    'DarkGray', 'Black', 'DarkRed', 'DarkOrange', 'DarkBrown', 'DarkYellow', 'DarkGreen', 'DarkTeal', 'DarkOlive', 'DarkBlue', 'DarkPurple', 'DarkCranberry'];

// used to show the color on UI
export const COLOR_KEYS = [
    '#E74856', '#FF8C00', '#FFAB45', '#FFF100', '#47D041', '#30C6CC', '#73AA24', '#00BCF2', '#8764B8', '#F495BF',
    '#A0AEB2', '#004B60', '#B1ADAB', '#5D5A58', '#000000', '#750B1C', '#CA5010', '#AB620D', '#C19C00', '#004B1C',
    '#004B50', '#0B6A0B', '#002050', '#32145A', '#5C005C'];

@Component({
    selector: 'tam-admin-exchange-server',
    templateUrl: './admin-exchange-server.component.html',
    styleUrls: ['./admin-exchange-server.component.scss']
})
export class AdminExchangeServerComponent implements OnInit, OnDestroy {
    // #region properties
    // public
    categoryError = '';
    categoryName = 'Deposited to Tamale';
    clickLabelStatus = false;
    clientId = '';
    clientSecret = '';
    colors = COLOR_KEYS;
    colorContainer = new Map();
    connectStatus = '';
    dataSource;
    exchangeConnect: any;
    error = '';
    integrationType = 'Graph API application';
    isEnable = false;
    isEnableCategoryNameColor = false;
    isEnableRemoveCategory = false;
    isShow = false;
    isEnableSyncAuto = false;
    lastUpdate;
    selectedColor = '#004B60';
    showPopup = false;
    suggestionItems = ['Contact from Tamale', 'Contact from exchange'];
    syncType = 'Contact from Tamale';
    tenant = '';
    type = 'password';

    // private
    private _destroySubscriptions: Array<Subscription> = [];
    private _isStartFetchapp = false;
    private _systemConfig;
    // #endregion

    // #region constructor
    constructor(
        private _authService: AuthService,
        private _dateHelperService: DateHelperService,
        private _emailSettingService: EmailSettingService,
        private _exchangeService: ExchangeService,
        private _exchangePanelService: ExchagnePanelService,
        private _slideSheetService: SlideSheetService,
        private _store: Store<AppState>,
        private _storeQuerierService: StoreQuerierService,
        private _toastService: ToastService,
    ) {
        this._systemConfig = this._storeQuerierService.queryBySelector(getSystemConfigState);
    }
    // #endregion

    // #region ngOnInit
    ngOnInit() {
        // create a color map to transfer color for server
        for (let i = 0; i < COLOR_KEYS.length; i++) {
            this.colorContainer.set(COLOR_KEYS[i], COLOR_VALUES[i]);
        }

        this._fetachAppAction(status);
        this._exchangeService.getConfigInfo().subscribe(res => {
            this.exchangeConnect = res;
            this.isShow = true;
            this.lastUpdate = !res.lastUpdate ? '' :
                this._dateHelperService.getDateStringByDateObject(new Date(res.lastUpdate), 'yyyy/mm/dd');

            const connectPara = this.exchangeConnect.connectInfo.connectPara;
            if (connectPara) {
                this.isEnable = this.exchangeConnect.connectInfo.enable;
                this.isEnableSyncAuto = this._systemConfig.autoSyncSetConfig.enable;
                if (this.isEnable) {
                    this.connectStatus = '(Connected)';
                }
                this.clientId = connectPara.clientId;
                this.tenant = connectPara.tenant;
                this.clientSecret = this._authService.decryptPassword(connectPara.clientSecret);
            }
            // init the category configuration information
            const categoryConfigInfo = this.exchangeConnect.categorySetConfig;
            if (categoryConfigInfo) {
                this.isEnableCategoryNameColor = categoryConfigInfo.enable;
                this.isEnableRemoveCategory = categoryConfigInfo.deleteCategoryWhenEntryDelete;
                if (categoryConfigInfo.setting && categoryConfigInfo.setting.default) {
                    this.categoryName = categoryConfigInfo.setting.default.name;
                    // to transfer the color aname to color key
                    this.selectedColor = this.getKeyByValue(this.colorContainer, categoryConfigInfo.setting.default.color);
                }
            }
        });
        this._destroySubscriptions.push(
            this._exchangePanelService.exchangeSave$.subscribe(res => {
                this.lastUpdate = !res.lastUpdate || res.lastUpdate === 0 ? '' :
                    this._dateHelperService.getDateStringByDateObject(new Date(res.lastUpdate), 'yyyy/mm/dd');
            }),
            this._slideSheetService.slideSheetActionSubject$.subscribe(res => {
                if (res && res.type && res.type === SlideSheetActionTypes.CLOSE) {
                    this.clickLabelStatus = false;
                }
            }));
    }
    // #endregion

    // #region ngOnDestroy
    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }
    // #endregion

    // #region public functions
    /**
     * To show color control to choose a color for category
     */
    addColor(event) {
        if (!this.isEnableCategoryNameColor) {
            this.showPopup = !this.showPopup;
            this.emptyClick(event);
        }
    }

    changeEnable(value) {
        this.connectStatus = '(Connecting)';
        const exchangeConnectModel = new ExchangeConnectModel();
        exchangeConnectModel.enable = value;
        exchangeConnectModel.connectPara = new ConnectPara();
        exchangeConnectModel.connectPara.clientId = this.clientId;
        exchangeConnectModel.connectPara.clientSecret = this._authService.encryptPassword(this.clientSecret),
            exchangeConnectModel.connectPara.tenant = this.tenant;

        delete exchangeConnectModel.connectInfo;
        this.exchangeConnect.connectInfo.enable = this.isEnable = value;
        this._exchangeService.putConfigConnect(exchangeConnectModel)
            .pipe(
                take(1),
                catchError((error) => {
                    if (error && error.message.indexOf('InvalidAuthenticationToken')) {
                        this.error = 'Connection failed. Please check your input and try again.';
                    }
                    this.connectStatus = '';
                    this.isEnable = false;
                    return observableOf(null);
                }),

            ).subscribe(res => {
                if (res) {
                    this.error = '';
                    this.connectStatus = '(Connected)';
                    this._store.dispatch(new ExchangeStatus(res.enable));
                    if (this._isStartFetchapp && res.enable) {
                        this._fetachAppAction(restart);
                    }
                }
            });
    }

    // enable the categroy configuration to send the request to server
    changeEmailEventIndicationEnable() {
        const exchangeConfigInfo = new ExchangeConfigInfo();
        exchangeConfigInfo.enable = this.isEnableCategoryNameColor;
        exchangeConfigInfo.deleteCategoryWhenEntryDelete = this.isEnableRemoveCategory;
        exchangeConfigInfo.setting = new SettingConfig();
        exchangeConfigInfo.setting.default = new DefaultConfig();
        exchangeConfigInfo.setting.default.name = this.categoryName;
        // get the color value by key
        exchangeConfigInfo.setting.default.color = this.colorContainer.get(this.selectedColor);
        this._exchangeService.putConfigCategory(exchangeConfigInfo)
            .pipe(
                take(1),
                catchError((error) => {
                    // error handling to show the error message
                    this.categoryError = error.message;
                    this.isEnableCategoryNameColor = !this.isEnableCategoryNameColor;
                    return observableOf(null);
                })
            ).subscribe(res => {
                if (res && res.enable) {
                    this._toast(NotificationStyles.Success, StringLiteralsPipe.translate('general.settings_saved_successfully'));
                } else {
                    {
                        this._toast(NotificationStyles.Success, StringLiteralsPipe.translate('general.indication_is_turned_off_successfully'));
                    }
                }
            });
    }

    /**
     * choose a color
     * @param color
     */
    chooseColor(color) {
        this.selectedColor = color;
    }

    /**
     * Change Auto Sync Status by request.
     *
     * @memberof AdminExchangeServerComponent
     */
    changeAutoSyncEnable() {
        this._exchangeService.updateAutoSycnSettingStatus(this.isEnableSyncAuto)
            .pipe(
                take(1),
                catchError((error) => {
                    this.isEnableSyncAuto = false;
                    return observableOf(null);
                }),

            ).subscribe(res => {
                if (res) {
                    this._store.dispatch(new ExchangeSyncStatus(res.enable));
                }
            }
            );
    }

    // hidden the color chooser control when click somewhere
    @HostListener('document:click', ['$event'])
    clickSomewhere(event) {
        if (this.showPopup) {
            this.showPopup = false;
        }
    }

    emptyClick($event) {
        if ($event.preventDefault) {
            $event.preventDefault();
        }
        if ($event.stopPropagation) {
            $event.stopPropagation();
        }
    }

    settingAutoSync() {
        this.clickLabelStatus = !this.clickLabelStatus;
        this._slideSheetService.slideSheetActionSubject$.next({
            type: this.clickLabelStatus ? SlideSheetActionTypes.EXCHANGE_SYNC_CONTACT : SlideSheetActionTypes.CLOSE,
            payload: {
                slideSheetAutoClose: false,
                autoClose: false,
                isFromAdminSetting: true
            }
        });
    }

    trackByFn(index) {
        return index;
    }

    viewMapping() {
        this.clickLabelStatus = !this.clickLabelStatus;
        this._slideSheetService.slideSheetActionSubject$.next({
            type: this.clickLabelStatus ? SlideSheetActionTypes.EXCHANGE_PANEL : SlideSheetActionTypes.CLOSE,
            payload: {
                slideSheetAutoClose: false,
                autoClose: false
            }
        });
    }
    // #endregion

    // #region private functions
    /**
    * Get /set fetch app status.
    *
    * @param action(status,start,stop)
    */
    private _fetachAppAction(action: string) {
        this._emailSettingService.putEmailAction(action).pipe(
            take(1)).subscribe(res => {
                if ((action === restart && res.message === 'successfully')) {
                    this._toast(NotificationStyles.Success, StringLiteralsPipe.translate('email.fetch_app_restart'));
                }
                if (action === status && res && res.message === 'started') {
                    this._isStartFetchapp = true;
                }
            }, error => {
                if (action === restart) {
                    this._toast(NotificationStyles.Error, StringLiteralsPipe.translate('email.fetchapp_restart_failed'));
                } else if (action === status) {
                    this._toast(NotificationStyles.Error, StringLiteralsPipe.translate('email.failed_to_get_fetch_app_status'));
                }
            });
    }

    // get key by value for showing on UI
    private getKeyByValue(map, searchValue): string {
        let colorKey = '';
        map.forEach((key, value) => {
            if (key === searchValue) {
                colorKey = value;
            }
        });
        return colorKey;
    }

    /**
    * unify toast notification.
    * @param type
    * @param msg
    */
    private _toast(type: NotificationStyles, msg: string) {
        const note = new NotificationOptions();
        note.style = type;
        note.message = msg;
        this._toastService.notify(note);
    }
    // #endregion
}
